import React from 'react';
import ActionButton from '@severalnines/bar-frontend-components/build/lib/General/ActionButton';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import { ButtonProps } from 'antd/lib/button';
import CcGroup from '../../../services/models/CcGroup';
import GroupEditModal from './GroupEditModal';
import { Space } from 'antd';
import TypographyText from '../../../common/TypographyText';
import { InfoCircleOutlined } from '@ant-design/icons';
import ButtonWithTooltip from '../../../common/Control/ButtonWithTooltip';

export default GroupEditButton;

export type GroupEditButtonProps = ButtonProps & {
    group: CcGroup;
    onSuccess?: () => void;
};

function GroupEditButton({ group, onSuccess, ...rest }: GroupEditButtonProps) {
    const isSystemGroup = group.isSystemUserOwnedGroup();
    return isSystemGroup ? (
        <ButtonWithTooltip
            type="link"
            size="small"
            {...rest}
            disabled={true}
            tooltipProps={{
                title: <span>System groups cannot be edited.</span>,
            }}
        >
            <Space>
                <TypographyText muted={true}>Edit</TypographyText>
                <TypographyText muted={true}>
                    <InfoCircleOutlined />
                </TypographyText>
            </Space>
        </ButtonWithTooltip>
    ) : (
        <ButtonWithForm
            button={<ActionButton {...rest}>Edit</ActionButton>}
            form={<GroupEditModal group={group} onSuccess={onSuccess} />}
        />
    );
}
